import { call, put, takeLatest } from "redux-saga/effects";
import {
  submitUserRequest,
  submitUserSuccess,
  submitUserFailure,
  logoutUserRequest,
  logoutUserSuccess,
  logoutUserFailure,
  signUpUserSuccess,
  signUpUserFailure,
  signUpUserRequest,
  resetRequest,
  resetSuccess,
  resetFailure,
  resetPasswordRequest,
  resetPasswordFailure,
  resetPasswordSuccess,
} from "../slices/user-slice";
import {
  logoutUser,
  postResetPassword,
  postResetPasswordEmail,
  postUserLogin,
  postUserRegister,
} from "../../services/user.service";
import { SignInRequest } from "../../models/request/sign_in_request";
import { SignInResponse } from "../../models/response/sign_in_response";
import { message } from "antd";

// Worker Saga
function* submitUser(action: { type: string; payload: SignInRequest }) {
  try {
    const data: SignInResponse = yield call(postUserLogin, action.payload);

    yield put(submitUserSuccess(data));
  } catch (error: any) {
    yield put(submitUserFailure(error?.response?.data?.message));
  }
}

function* signOutUser(action: { type: string }) {
  try {
    const data: string = yield call(logoutUser);
    yield put(logoutUserSuccess(data));
  } catch (error: any) {
    yield put(logoutUserFailure(error?.response?.data?.message));
  }
}

function* signUpUser(action: { type: string; payload: any }) {
  try {
    const data: string = yield call(postUserRegister, action.payload);
    yield put(signUpUserSuccess(data));
  } catch (error: any) {
    yield put(signUpUserFailure(error.message));
  }
}

function* resetPasswordEmailSend(action: { type: string; payload: any }) {
  try {
    const response: { data: any } = yield call(postResetPasswordEmail, action.payload);
    yield put(resetSuccess(response.data));
  } catch (error: any) {
    yield put(resetFailure(error.message));
  }
}

function* resetPassword(action: { type: string; payload: any }) {
  try {
    const response: { data: any } = yield call(postResetPassword, action.payload);
    yield put(resetPasswordSuccess(response.data));
  } catch (error: any) {
    yield put(resetPasswordFailure(error.message));
  }
}

// Watcher Saga
export default function* userSaga() {
  yield takeLatest(submitUserRequest.type, submitUser);
  yield takeLatest(logoutUserRequest.type, signOutUser);
  yield takeLatest(signUpUserRequest.type, signUpUser);
  yield takeLatest(resetRequest.type, resetPasswordEmailSend);
  yield takeLatest(resetPasswordRequest.type, resetPassword);
}
